import { Button } from "@/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/Tooltip";
import {
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowUpIcon,
} from "@heroicons/react/24/outline";
import React from "react";

interface SortButtonProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  isActive: boolean;
  ascending?: boolean;
  onClick: () => void;
  tooltipTextAscending: string;
  tooltipTextDescending: string;
}

export const RoundButtonWithSortingIcon: React.FC<SortButtonProps> = ({
  icon: Icon,
  isActive,
  ascending = true,
  onClick,
  tooltipTextAscending,
  tooltipTextDescending,
}) => {
  const getTooltipText = () => {
    if (!isActive) return tooltipTextDescending; // default if not active
    return ascending ? tooltipTextAscending : tooltipTextDescending;
  };

  return (
    <div className="group relative">
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="outline"
              size="icon"
              className={`relative rounded-full p-2 transition-all ${
                isActive
                  ? "border-transparent bg-hover"
                  : "border-transparent hover:border-input"
              }`}
              onClick={onClick}
            >
              <Icon className={`size-5 transition-transform group-hover:scale-110 ${isActive ? "text-softiq-primary" : "text-foreground"}`} />

              {isActive ? (
                ascending ? (
                  <ArrowUpIcon className="absolute left-5 top-1 h-3 w-3 text-softiq-primary" />
                ) : (
                  <ArrowDownIcon className="absolute left-5 top-1 h-3 w-3 text-softiq-primary" />
                )
              ) : (
                <ArrowsUpDownIcon className="absolute left-5 top-1 h-3 w-3 text-foreground" />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="top" sideOffset={15}>
            {getTooltipText()}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
